import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Campaingns() {
    const [templates, setTemplates] = useState([]);
    const [message, setMessage] = useState("");
    const [subject, setSubject] = useState("");
    const [recipients, setRecipients] = useState([]);
    const navigate = useNavigate();
    const [alertMsg, setAlertMsg] = useState("");
    const [showAlertBox, setShowAlertBox] = useState(false);
    useEffect(() => {
        let company_id = localStorage.getItem('mem_company_id');
        fetch("get_templates.php", {
            method: 'POST',
            body: new URLSearchParams({
                company_id: company_id
            })
        })
            .then(res => res.json())
            .then(data => {
                setTemplates(data);
            });
    }, [])

    const showAlert = (msg) => {
        setAlertMsg(msg);
        setShowAlertBox(true);
    };

    const closeAlert = () => {
        setShowAlertBox(false);
        setAlertMsg("");
        localStorage.setItem('communications', 'campaign');
        navigate('/redirect_communications');
    };

    const loadTemplate = (templateId) => {

        if (templateId === "") return;

        fetch("get_template_details.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded"
            },
            body: "template_id=" + templateId
        })
            .then(res => res.json())
            .then(data => {

                setSubject(data.subject);
                setMessage(data.body);

            });

    }

    const addRecipient = () => {
        setRecipients([
            ...recipients,
            { name: "", email: "" }
        ]);
    };

    const updateRecipient = (index, field, value) => {
        const updated = [...recipients];
        updated[index][field] = value;
        setRecipients(updated);
    };

    const removeRecipient = (index) => {
        const updated = recipients.filter((_, i) => i !== index);
        setRecipients(updated);
    };

    const sendCampaign = () => {

        let company_id = localStorage.getItem('mem_company_id');
        let company_email = localStorage.getItem('useremail');
        let company_name = localStorage.getItem('mem_company_name');
        document.getElementById('waitloader').style.display = 'block';
        document.getElementById('waitloaderinner').style.display = 'block';

        const data = {
            company_id: company_id,
            campaign_name: document.getElementById('campname').value,
            template_id: document.getElementById('template').value,
            subject: subject,
            message: message,
            event_date: document.getElementById('event_date').value,
            event_time: document.getElementById('event_time').value,
            event_location: document.getElementById('event_location').value,
            recipients: recipients,
            company_email: company_email,
            company_name: company_name
        };

        console.log(data);

        // Validation
        if (!data.campaign_name) {
            showAlert("Campaign name is required");
            return;
        }

        if (recipients.length === 0) {
            showAlert("Please add at least one recipient");
            return;
        }

        fetch("create_campaign.php", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(res => {
                console.log(res);
                if (res.status === "success") {
                    document.getElementById('waitloader').style.display = 'none';
                    document.getElementById('waitloaderinner').style.display = 'none';
                    showAlert("Campaign sent successfully");
                } else {
                    showAlert("Something went wrong");
                }

            });

    };


    return (
        <div>
            <div className='fullwidth pull_left'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Create Campaign</h2>
                    <button className='pull_right green_button send_btn' onClick={sendCampaign}>Send</button>
                    <button className='pull_right borderbutton mr-10'>Cancel</button>
                </div>
                <div className='vl_dsh_formnholder'>
                    <div className='row'>
                        <div className='vl_dsh_one_half'>
                            <div className='formfieldcommon'>
                                <label>Campaign Name</label>
                                <input id="campname" type="text" />
                            </div>
                        </div>
                        <div className='vl_dsh_one_half'>
                            <div className='formfieldcommon'>
                                <label>Select Template</label>
                                <select id="template" onChange={(e) => loadTemplate(e.target.value)}>
                                    <option value="">Please select a template</option>
                                    {templates.map((t) => (
                                        <option key={t.id} value={t.id}>
                                            {t.template_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className='separator'>
                        <h4>Email Content</h4>
                    </div>
                    <div className='row'>
                        <div className='vl_dsh_one_half'>
                            <div className='formfieldcommon'>
                                <label>Event Date</label>
                                <input type="date" id="event_date" />
                            </div>
                        </div>
                        <div className='vl_dsh_one_half'>
                            <div className='formfieldcommon'>
                                <label>Event Time</label>
                                <input type="time" id="event_time" />
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='vl_dsh_one_half'>
                            <div className='formfieldcommon'>
                                <label>Location / Meeting Link</label>
                                <input type="text" id="event_location" />
                            </div>
                        </div>
                        <div className='vl_dsh_one_half'>
                            <div className='formfieldcommon'>
                                <label>Subject</label>
                                <input type="text" id="subject" value={subject} onChange={(e) => setSubject(e.target.value)} />
                            </div>
                        </div>
                    </div>
                    <div className='formfieldcommon'>
                        <label>Message</label>
                        <textarea id="msgfield"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            rows="8"
                        ></textarea>
                    </div>
                    <div className='separator'>
                        <h4>Add Reicipient</h4>
                    </div>
                    <div className='reicipient_area fullwidth pull_left'>
                        <div className='vl_dsh_buttonholder'>
                            <button className="greenbutton pull_left mr-10" onClick={addRecipient}>+ Add Recipient</button>
                        </div>
                        <div className='reicipientblock fullwidth pull_left'>
                            {recipients.map((r, index) => (
                                <div className='reicipient_row' key={index}>
                                    <input type="text" placeholder="Name" value={r.name} onChange={(e) => updateRecipient(index, 'name', e.target.value)} className="reicipient_name_input" />

                                    <input type="email" placeholder="Email" value={r.email}
                                        onChange={(e) => updateRecipient(index, 'email', e.target.value)}
                                        className="reicipient_mail_input" />

                                    <button className='borderbutton pull_left mt-7' onClick={() => removeRecipient(index)}><i class="ri-close-circle-line"></i> Remove</button>

                                </div>

                            ))}

                        </div>
                    </div>
                    <div className='fullwidth pull_left mt-30'>
                        <button className='pull_right green_button send_btn' onClick={sendCampaign}>Send</button>
                        <button className='pull_right borderbutton mr-10'>Cancel</button>
                    </div>
                </div>
            </div>
            {showAlertBox && (
                <div className='vl_dsh_popup_vis'>
                    <div className='alertbox'>
                        <div className='alertheader'>
                            <h3><i className='ri-alert-line'></i>Alert</h3>
                        </div>
                        <div className='contentarea'>
                            <p>{alertMsg}</p>
                        </div>
                        <div className='alert_btns'>
                            <button onClick={closeAlert}>Okay</button>
                        </div>
                    </div>
                </div>
            )}

            <div className='loaderpop' id='waitloader'>
                <div className='loader_inner' id="waitloaderinner">
                    <p id="loadtext"></p>
                </div>
            </div>
        </div>
    )
}
